import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import { useAuth } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import TotpLoginDialog from './components/auth/TotpLoginDialog';
import { ThemeProvider } from './context/ThemeContext';
import { SignupProvider } from './context/SignupContext';
import { ContentProvider } from './context/ContentContext';
import AdminGallery from './pages/AdminGallery';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Member from './pages/Member';
import MemberCenter from './pages/MemberCenter';
import Contact from './pages/Contact';
import Aktiviteter from './pages/Aktiviteter';
import Reviews from './pages/Reviews';
import AuthCallback from './pages/AuthCallback';
import OAuthCallback from './pages/OAuthCallback';
import Gallery from './pages/Gallery';
import NotFound from './pages/NotFound';
import MemberCardVerify from './pages/MemberCardVerify';
import Videos from './pages/Videos';
import AdminMembers from './pages/AdminMembers';
import AdminPanel from './pages/AdminPanel';
import AdminConsole from './pages/AdminConsole';
import AdminNewsletter from './pages/AdminNewsletter';
import Unsubscribe from './pages/Unsubscribe';
import PrivacyPolicy from './pages/PrivacyPolicy';
import MemberAIWidget from './components/member/MemberAIWidget';

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/p-policy" element={<PrivacyPolicy />} />
      <Route path="/auth/oauth/:provider" element={<OAuthCallback />} />
      <Route path="/medlem" element={<Member />} />
      <Route path="/medlemssenter" element={<MemberCenter />} />
      <Route path="/sporsmal" element={<Contact />} />
      <Route path="/aktiviteter" element={<Aktiviteter />} />
      <Route path="/anmeldelser" element={<Reviews />} />
      <Route path="/kort/:code" element={<MemberCardVerify />} />
      <Route path="/videoar" element={<Videos />} />
      <Route path="/galleri" element={<Gallery />} />
      <Route path="/admin_console" element={<AdminConsole />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/admin/nyheitsbrev" element={<AdminNewsletter />} />
      <Route path="/admin/galleri" element={<AdminGallery />} />
      <Route path="/nyheitsbrev/avmeld/:token" element={<Unsubscribe />} />
      <Route path="/admin/medlemmer" element={<AdminMembers />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const TotpLoginGate = () => {
  const { totpChallenge, cancelTotpChallenge, completeTotpChallenge } = useAuth();
  return <TotpLoginDialog challengeId={totpChallenge} onCancel={cancelTotpChallenge} onVerified={completeTotpChallenge} />;
};

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
      <LanguageProvider>
      <ThemeProvider>
      <SignupProvider>
        <BrowserRouter>
          <AppRouter />
          <TotpLoginGate />
          <MemberAIWidget />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </SignupProvider>
      </ThemeProvider>
      </LanguageProvider>
      </ContentProvider>
      </AuthProvider>
  );
}

export default App;
